import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { Tooltip, Fade } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

//helpers:
import { getData, postData, putData } from '../../dataLib';

//actions:
import { openDialog, hideDialog } from '../../actions/index';
import { modifyDatosCierreDiario } from '../../actions/cierre_diario_actions';

//components:
import FloatNumberFormatInput from '../../components/float_number_input_formatter';
import IntNumberFormatInput from '../../components/int_number_input_formatter';


const styles = theme => ({
    formContainer: {
        padding: '20px 5px',
    },
    hoursContainer: {
        display: 'flex',
        flexFlow: 'column wrap',
        alignContent: 'space-between',
        maxHeight: 410,
        marginBottom: 10,
        width: '100%',
        margin: '0 auto',
    },
    formItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 15,
    },
    label: {
        textAlign: 'left',
        fontSize: 11,
        marginRight: theme.spacing(1),
    },
    total: {
        display: 'flex',
        fontWeight: '500',
        textTransform: 'capitalize',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: 200,
        margin: '30px 8px 20px 0',
    },
    inputImporte: {
        textAlign: 'right',
        margin: 8,
        padding: 0,
        fontSize: 11,
    },
    input: {
        width: 70,
        height: 30,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        },
    },
    button: {
        margin: '15px 15px 15px 0',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
    divSpinner: {
        display: 'inline',
        margin: 15
    },
    spinner: {
        width: 40,
        height: 40,
    },

});

class CierreDiarioPorHoras extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            desglose:
            {
                id: -1,
                articuloId: -1,
                fecha: this.props.centroDiaSelected.dia,
                usuarioId: 0,
                hora01: 0.0,
                hora02: 0.0,
                hora03: 0.0,
                hora04: 0.0,
                hora05: 0.0,
                hora06: 0.0,
                hora07: 0.0,
                hora08: 0.0,
                hora09: 0.0,
                hora10: 0.0,
                hora11: 0.0,
                hora12: 0.0,
                hora13: 0.0,
                hora14: 0.0,
                hora15: 0.0,
                hora16: 0.0,
                hora17: 0.0,
                hora18: 0.0,
                hora19: 0.0,
                hora20: 0.0,
                hora21: 0.0,
                hora22: 0.0,
                hora23: 0.0,
                hora24: 0.0,
            },
            total: 0.0,
            normal: 0.0,
            packs: 0.0,
            loading: true
        }
    }

    componentDidMount() {

        this.getDesglose();
    }

    calculateTotal = (desglose) => {
        let total = 0.0;

        total += parseFloat(desglose.hora01);
        total += parseFloat(desglose.hora02);
        total += parseFloat(desglose.hora03);
        total += parseFloat(desglose.hora04);
        total += parseFloat(desglose.hora05);
        total += parseFloat(desglose.hora06);
        total += parseFloat(desglose.hora07);
        total += parseFloat(desglose.hora08);
        total += parseFloat(desglose.hora09);
        total += parseFloat(desglose.hora10);
        total += parseFloat(desglose.hora11);
        total += parseFloat(desglose.hora12);
        total += parseFloat(desglose.hora13);
        total += parseFloat(desglose.hora14);
        total += parseFloat(desglose.hora15);
        total += parseFloat(desglose.hora16);
        total += parseFloat(desglose.hora17);

        return total;
    }

    getDesglose = () => {

        let desgloseURL = '';

        if (this.props.producto.iKind === -5) desgloseURL += 'dedesglosehoras/cierrediario?zona_id=' + this.props.producto.zonaId + '&date=' + this.props.centroDiaSelected.dia;
        else desgloseURL += 'dadesglosehoras/cierrediario?zona_id=' + this.props.producto.zonaId + '&date=' + this.props.centroDiaSelected.dia;

        getData(desgloseURL,
            (response) => {
                this.setState({ ...this.state, desglose: response.data, total: this.calculateTotal(response.data), loading: false })
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR fetching desglose horas'
                }, uuidv4(), false, 'sm');
            },
            this.props.user
        );

    }

    updateDesglose = () => {

        console.log(this.props.producto);
        console.log(this.props.centroDiaSelected.centro);
        

        let desgloseURL = '';

        this.setState({ ...this.state, loading: true });

        if (this.props.producto.iKind === -5) desgloseURL += 'dedesglosehoras/' + this.state.desglose.id;
        else {

            const art2 = this.props.productoRelacionado ? this.props.productoRelacionado.articuloId : '0';

            desgloseURL += 'dadesglosehoras/' + this.state.desglose.id;
            if (this.props.centroDiaSelected.centro.sigfrid !== -1 && this.props.producto.iKind === -7) {
                desgloseURL += '?art1=' + this.props.producto.articuloId + '&art2=' + art2 + '&normal=' + this.state.normal + '&packs=' + this.state.packs;
            }
        }

        putData(desgloseURL,
            () => {
                this.props.hideDialog();
                const message = this.props.producto.iKind === -7 ? 'Ventas Bar y franjas horarias importadas' : 'Ventas por hora actualizadas'
                this.props.openDialog('SimpleMessage', {
                    message: message
                }, uuidv4(), false, 'sm');
                if (this.props.centroDiaSelected.centro.sigfrid !== -1 && this.props.producto.iKind === -7) {
                    this.props.modifyDatosCierreDiario({ ...this.props.producto, button1: this.state.total, importe: this.state.normal });
                    this.props.modifyDatosCierreDiario({ ...this.props.productoRelacionado, importe: this.state.packs });
                }
                else {
                    if(this.props.producto.iKind === -7) this.props.modifyDatosCierreDiario({ ...this.props.producto, button1: this.state.total });
                    else this.props.modifyDatosCierreDiario({ ...this.props.producto, button2: this.state.total });
                }

            },
            () => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR actualizando ventas por hora'
                }, uuidv4(), false, 'sm');
                this.setState({ ...this.state, loading: false });
            },
            this.state.desglose,
            this.props.user
        );

    }

    newDesglose = () => {
        let desgloseURL = '';

        this.setState({ ...this.state, loading: true });

        if (this.props.producto.iKind === -5) desgloseURL += 'dedesglosehoras';
        else {
            desgloseURL += 'dadesglosehoras';

            const art2 = this.props.productoRelacionado ? this.props.productoRelacionado.articuloId : '0';

            if (this.props.centroDiaSelected.centro.sigfrid !== -1 && this.props.producto.iKind === -7) {
                desgloseURL += '?art1=' + this.props.producto.articuloId + '&art2=' + art2 + '&normal=' + this.state.normal + '&packs=' + this.state.packs;
            }
        }

        postData(desgloseURL,
            () => {
                this.props.hideDialog();
                const message = this.props.producto.iKind === -7 ? 'Ventas Bar y franjas horarias importadas' : 'Ventas por hora actualizadas'
                this.props.openDialog('SimpleMessage', {
                    message: message
                }, uuidv4(), false, 'sm');
                if (this.props.centroDiaSelected.centro.sigfrid !== -1 && this.props.producto.iKind === -7) {
                    this.props.modifyDatosCierreDiario({ ...this.props.producto, button1: this.state.total, importe: this.state.normal });
                    this.props.modifyDatosCierreDiario({ ...this.props.productoRelacionado, importe: this.state.packs });
                }
                else {
                    if(this.props.producto.iKind === -7) this.props.modifyDatosCierreDiario({ ...this.props.producto, button1: this.state.total });
                    else this.props.modifyDatosCierreDiario({ ...this.props.producto, button2: this.state.total });
                }
            },
            () => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR updating desglose horas 2'
                }, uuidv4(), false, 'sm');

                this.setState({ ...this.state, loading: false });
            },
            this.state.desglose,
            this.props.user
        );

    }

    handleValueChange = (event, field) => {
        //const value = (event.target.value === '') ? 0 : event.target.value
        let newDesglose = { ...this.state.desglose, [field]: event.target.value };
        this.setState({ ...this.state, desglose: newDesglose, total: this.calculateTotal(newDesglose) });
    }


    handleBlur = (event, field) => {
        if (event.target.value === '') {
            let newDesglose = { ...this.state.desglose, [field]: 0 };
            this.setState({ ...this.state, desglose: newDesglose, total: this.calculateTotal(newDesglose) });
        }
    }


    renderTextField = (label, field, inputComponent) => {

        const { classes } = this.props;

        return (

            <div className={classes.formItem}>
                <Typography variant="subtitle2" className={classes.label}>
                    {label}
                </Typography>

                <TextField
                    className={classes.input}
                    id={field}
                    placeholder='0'
                    value={this.state.desglose[field]}
                    onChange={(event) => this.handleValueChange(event, field)}
                    onBlur={(event) => this.handleBlur(event, field)}
                    InputProps={{ classes: { input: classes.inputImporte }, inputComponent: inputComponent }}
                    variant="outlined"
                    disabled={this.props.isDiaCerrado || (this.props.centroDiaSelected.centro.sigfrid !== -1 && this.props.producto.iKind === -7)}
                />

            </div>
        )
    }


    // importSigfrid = () => {

    //     const getURL = 'sigfrid?centro_id=' + this.props.centroDiaSelected.centro.sigfrid + '&date=' + this.props.centroDiaSelected.dia;

    //     getData(getURL,
    //         (response) => {

    //             let totales = [];

    //             let normal = 0.0;
    //             let packs = 0.0;

    //             for (const key in response.data.datos) {

    //                 if (key !== "local" && key !== "fecha" && key !== "cabeceras" && key !== "totales") {

    //                     const linea = response.data.datos[key];

    //                     if (linea[19].value20 === null) {

    //                         const hora = parseInt(linea[12].value13.slice(0, 2));
    //                         const importe = parseFloat(linea[8].value9.replace('.', '').replace(',', '.'));
    //                         const tipo = linea[13].value14;

    //                         if (totales[hora] !== undefined) totales[hora] += importe;
    //                         else totales[hora] = importe;

    //                         if (tipo === "MESA") packs += importe;
    //                         else normal += importe;

    //                     }
    //                 }
    //             }

    //             var newDesglose = { ...this.state.desglose };

    //             let antes12 = 0.0;
    //             for (let i = 5; i <= 12; i++) {
    //                 if (totales[i] !== undefined) antes12 += totales[i];
    //             }

    //             newDesglose.hora01 = antes12;
    //             newDesglose.hora02 = totales[13] ? totales[13] : 0.0;
    //             newDesglose.hora03 = totales[14] ? totales[14] : 0.0;
    //             newDesglose.hora04 = totales[15] ? totales[15] : 0.0;
    //             newDesglose.hora05 = totales[16] ? totales[16] : 0.0;
    //             newDesglose.hora06 = totales[17] ? totales[17] : 0.0;
    //             newDesglose.hora07 = totales[18] ? totales[18] : 0.0;
    //             newDesglose.hora08 = totales[19] ? totales[19] : 0.0;
    //             newDesglose.hora09 = totales[20] ? totales[20] : 0.0;
    //             newDesglose.hora10 = totales[21] ? totales[21] : 0.0;
    //             newDesglose.hora11 = totales[22] ? totales[22] : 0.0;
    //             newDesglose.hora12 = totales[23] ? totales[23] : 0.0;
    //             newDesglose.hora13 = totales[0] ? totales[0] : 0.0;
    //             newDesglose.hora14 = totales[1] ? totales[1] : 0.0;
    //             newDesglose.hora15 = totales[2] ? totales[2] : 0.0;
    //             newDesglose.hora16 = totales[3] ? totales[3] : 0.0;
    //             newDesglose.hora17 = totales[4] ? totales[4] : 0.0;

    //             this.setState({ ...this.state, desglose: newDesglose, total: this.calculateTotal(newDesglose), normal: normal, packs: packs });

    //         },
    //         (error) => {
    //             this.props.openDialog('SimpleMessage', {
    //                 message: 'ERROR fetching sigfrid'
    //             }, uuidv4(), false, 'sm');
    //         },
    //         this.props.user
    //     );

    // }

    importSigfrid = () => {

        this.props.importSigfrid((response) => {
            const newDesglose = { ...response.desglose, id: this.state.desglose.id, articuloId: this.state.desglose.articuloId, fecha: this.props.centroDiaSelected.dia };
            this.setState({ ...this.state, desglose: newDesglose, total: this.calculateTotal(newDesglose), normal: response.normal, packs: response.packs });
        });

    }

    render() {
        const { classes } = this.props;

        const inputComponent = this.props.dataType === 'int' ? IntNumberFormatInput : FloatNumberFormatInput;

        return (
            <form className={classes.formContainer}>

                <div className={classes.hoursContainer}>

                    {this.renderTextField('12:00 - 13:00', 'hora01', inputComponent)}
                    {this.renderTextField('13:00 - 14:00', 'hora02', inputComponent)}
                    {this.renderTextField('14:00 - 15:00', 'hora03', inputComponent)}
                    {this.renderTextField('15:00 - 16:00', 'hora04', inputComponent)}
                    {this.renderTextField('16:00 - 17:00', 'hora05', inputComponent)}
                    {this.renderTextField('17:00 - 18:00', 'hora06', inputComponent)}
                    {this.renderTextField('18:00 - 19:00', 'hora07', inputComponent)}
                    {this.renderTextField('19:00 - 20:00', 'hora08', inputComponent)}
                    {this.renderTextField('20:00 - 21:00', 'hora09', inputComponent)}
                    {this.renderTextField('21:00 - 22:00', 'hora10', inputComponent)}
                    {this.renderTextField('22:00 - 23:00', 'hora11', inputComponent)}
                    {this.renderTextField('23:00 - 00:00', 'hora12', inputComponent)}
                    {this.renderTextField('00:00 - 01:00', 'hora13', inputComponent)}
                    {this.renderTextField('01:00 - 02:00', 'hora14', inputComponent)}
                    {this.renderTextField('02:00 - 03:00', 'hora15', inputComponent)}
                    {this.renderTextField('03:00 - 04:00', 'hora16', inputComponent)}
                    {this.renderTextField('04:00 - 05:00', 'hora17', inputComponent)}

                </div>


                <div className={classes.total}>
                    <p style={{ margin: 0 }}>Total</p>

                    <TextField
                        id="total"
                        value={this.state.total}
                        disabled
                        variant="outlined"
                        className={classes.input}
                        style={{ width: 80 }}
                        InputProps={{ classes: { input: classes.inputImporte }, inputComponent: inputComponent }}
                    />
                </div>

                {this.props.producto.iKind === -7 && !this.props.isDiaCerrado && this.props.centroDiaSelected.centro.sigfrid !== -1 ?
                    <Tooltip hidden title={'Importar valores de la aplicación del bar'} TransitionComponent={Fade} TransitionProps={{ timeout: 500 }} placement="right" classes={{ tooltip: this.props.classes.tooltip }}>
                        <Button variant="contained" color="primary" className={classes.button} onClick={() => { this.importSigfrid() }}>Importar Sigfrid</Button>
                    </Tooltip>
                    : ''}

                <div>
                    <Button disabled={this.state.loading} variant="contained" color="secondary" className={classes.button} onClick={() => { this.props.hideDialog() }}>Cerrar</Button>
                    {!this.props.isDiaCerrado && //no es un dia cerrado
                        ((this.props.producto.iKind === -7 && this.props.centroDiaSelected.centro.sigfrid === -1) // es de bar pero no tiene sigfrid (no deberia pasar nunca)
                            || this.props.producto.iKind !== -7) ? // no es bar

                        <Button disabled={this.state.loading} variant="contained" color="primary" className={classes.button} onClick={() => {
                            if (this.state.desglose.id === -1) this.newDesglose();
                            else this.updateDesglose();
                        }}>Guardar</Button>

                        : ''}
                    <div className={classes.divSpinner}><CircularProgress hidden={!this.state.loading} className={classes.spinner} color="primary" /> </div>

                </div>

            </form>
        );

    }

}

CierreDiarioPorHoras.propTypes = {
    dataType: PropTypes.string.isRequired,
    producto: PropTypes.object.isRequired,
    productoRelacionado: PropTypes.object,
    centroDiaSelected: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    isDiaCerrado: PropTypes.bool.isRequired,
    hideDialog: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    modifyDatosCierreDiario: PropTypes.func.isRequired,
};

function mapStateToProps(state) {

    return {
        centroDiaSelected: state.centroDiaSelected,
        isDiaCerrado: state.centroDiaSelected.isDiaCerrado,
        user: state.oidc.user,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        hideDialog,
        openDialog,
        modifyDatosCierreDiario
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(CierreDiarioPorHoras));